module.exports = __webpack_public_path__ + "static/media/tick.4db751de.svg";